import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetAgents as GetAgentsQuery} from 'nutshell-graphql-types';

import GET_AGENTS from '../queries/get-agents.graphql';

export const useGetAgents = () => {
    const {data, loading, error, refetch} = useQuery<GetAgentsQuery, Record<any, any>>(
        GET_AGENTS,
        {}
    );

    const chatAgents = data ? data.chatAgents : null;

    return {
        chatAgents,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
